import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
export default function ServerErr() {
  const { t  } = useTranslation("errors");

  return (
    <>
    <Box sx={{ width: "100%",height:"calc(100vh - 100px)", display: "flex", justifyContent: "center", alignItems: "center", flexDirection:"column" }}>
      <Typography sx={{marginBottom:"20px", fontSize:"42px", fontWeight:"900", letterSpacing:"2px", color:"#ff6b5c", textTransform:"capitalize"}}>{(t("unexpected"))}</Typography>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="471.14799"
        x="0"
        y="0"
        viewBox="0 0 511.999 511.999"
        class=""
      >
        <g>
          <path
            d="M470.637 419.577H41.363c-18.472 0-33.446-14.974-33.446-33.446V45.215c0-18.472 14.974-33.446 33.446-33.446h429.275c18.472 0 33.446 14.974 33.446 33.446v340.916c0 18.472-14.975 33.446-33.447 33.446z"
            
            fill="#53515e"
            data-original="#53515e"
            className=""
          ></path>
          <path
            d="M470.637 11.769H41.363c-18.472 0-33.446 14.975-33.446 33.446v46.983h496.167V45.215c0-18.472-14.975-33.446-33.447-33.446z"
            
            fill="#6f4bef"
            data-original="#6f4bef"
          ></path>
          <path
            d="M454.459 315.025H60.021c-16.897 0-30.595 13.698-30.595 30.595v71.755a33.345 33.345 0 0 0 11.937 2.202h429.275a33.316 33.316 0 0 0 14.416-3.26V345.62c0-16.897-13.698-30.595-30.595-30.595z"
            
            fill="#474756"
            data-original="#474756"
            className=""
          ></path>
          <path
            d="M434.833 500.231H79.646c-15.216 0-27.551-12.335-27.551-27.551V361.006c0-15.216 12.335-27.551 27.551-27.551h355.187c15.216 0 27.551 12.335 27.551 27.551v111.675c0 15.216-12.335 27.55-27.551 27.55z"
            
            fill="#ff6b5c"
            data-original="#ff6b5c"
          ></path>
          <path
            d="M434.833 333.455h-16.629c0 72.433-58.719 131.152-131.152 131.152H52.096v8.074c0 15.216 12.335 27.551 27.551 27.551h355.187c15.216 0 27.551-12.335 27.551-27.551V361.006c-.001-15.216-12.336-27.551-27.552-27.551z"
            
            fill="#ff5450"
            data-original="#ff5450"
          ></path>
          <path
            d="M470.638 3.852H41.363C18.556 3.852 0 22.407 0 45.215v340.916c0 22.808 18.556 41.363 41.363 41.363h2.816v45.186c0 19.556 15.911 35.467 35.467 35.467h355.187c19.556 0 35.467-15.91 35.467-35.467v-45.186h.337c22.808 0 41.362-18.556 41.362-41.363V45.215C512 22.407 493.445 3.852 470.638 3.852zM41.363 19.685h429.275c14.077 0 25.529 11.452 25.529 25.529V84.28H15.833V45.215c0-14.077 11.452-25.53 25.53-25.53zm429.275 391.976h-.337v-50.656c0-19.556-15.911-35.467-35.467-35.467h-65.868V194.122a7.917 7.917 0 1 0-15.834 0v131.416H137.274c-4.373 0-7.917 3.544-7.917 7.917s3.544 7.917 7.917 7.917h297.56c10.827 0 19.634 8.807 19.634 19.634v111.676c0 10.827-8.807 19.634-19.634 19.634H79.646c-10.827 0-19.634-8.807-19.634-19.634V361.005c0-10.827 8.807-19.634 19.634-19.634h14.878c4.373 0 7.917-3.544 7.917-7.917s-3.544-7.917-7.917-7.917H79.646c-19.556 0-35.467 15.911-35.467 35.467v50.656h-2.816c-14.078 0-25.53-11.452-25.53-25.53V100.114h337.3v59.967a7.917 7.917 0 1 0 15.834 0v-59.967h127.201v286.017c-.001 14.078-11.453 25.53-25.53 25.53z"
            fill="#000000"
            data-original="#000000"
            className=""
          ></path>
          <path
            d="M174.438 60.466h147.264c4.373 0 7.917-3.544 7.917-7.917s-3.544-7.917-7.917-7.917H174.438a7.917 7.917 0 1 0 0 15.834z"
            fill="#000000"
            data-original="#000000"
            className=""
          ></path>
          <circle
            cx="52.1"
            cy="52.55"
            r="7.5"
            fill="#000000"
            data-original="#000000"
            className=""
          ></circle>
          <circle
            cx="92.88"
            cy="52.55"
            r="7.5"
            fill="#000000"
            data-original="#000000"
            className=""
          ></circle>
          <circle
            cx="131.39"
            cy="52.55"
            r="7.5"
            fill="#000000"
            data-original="#000000"
            className=""
          ></circle>
          <circle
            cx="461.04"
            cy="52.55"
            r="7.5"
            fill="#000000"
            data-original="#000000"
            className=""
          ></circle>
          <path
            d="M111.4 377.796c-1.432.896-2.146 2.165-2.146 3.81v68.146c0 1.646.714 2.916 2.146 3.809 1.431.897 3.147 1.342 5.151 1.342h38.205c1.645 0 2.898-.714 3.756-2.146.858-1.431 1.287-3.113 1.287-5.045 0-2.074-.447-3.826-1.341-5.257-.896-1.431-2.13-2.146-3.703-2.146h-28.761v-18.244h16.097c1.645 0 2.898-.644 3.756-1.932.859-1.287 1.287-2.753 1.287-4.401 0-1.787-.447-3.326-1.341-4.614-.896-1.289-2.13-1.932-3.703-1.932h-16.097V391.05h28.761c1.573 0 2.807-.715 3.703-2.146.894-1.431 1.341-3.183 1.341-5.259 0-1.932-.43-3.612-1.287-5.044-.859-1.43-2.111-2.146-3.756-2.146H116.55c-2.003 0-3.719.447-5.15 1.341zM169.564 453.56c1.645.897 3.612 1.342 5.902 1.342 2.289 0 4.256-.445 5.902-1.342 1.645-.893 2.469-2.163 2.469-3.809v-25.864h7.083l14.702 28.547c1.073 2.076 2.86 3.111 5.365 3.111 2.504 0 4.883-.928 7.136-2.789 2.254-1.86 3.381-3.826 3.381-5.902 0-.786-.179-1.431-.537-1.932l-13.092-23.717c8.656-3.362 12.985-10.625 12.985-21.785 0-15.31-8.8-22.965-26.4-22.965h-22.214c-1.502 0-2.737.501-3.703 1.502-.966 1.003-1.448 2.183-1.448 3.542v68.253c.001 1.646.822 2.916 2.469 3.808zm14.273-62.51h10.624c3.148 0 5.544.769 7.191 2.307 1.645 1.539 2.468 4.096 2.468 7.673 0 3.578-.823 6.135-2.468 7.673-1.647 1.538-4.043 2.307-7.191 2.307h-10.624v-19.96zM232.236 453.56c1.645.897 3.612 1.342 5.902 1.342 2.289 0 4.256-.445 5.902-1.342 1.645-.893 2.469-2.163 2.469-3.809v-25.864h7.083l14.702 28.547c1.073 2.076 2.861 3.111 5.365 3.111s4.883-.928 7.136-2.789c2.254-1.86 3.381-3.826 3.381-5.902 0-.786-.179-1.431-.537-1.932l-13.092-23.717c8.656-3.362 12.985-10.625 12.985-21.785 0-15.31-8.8-22.965-26.4-22.965h-22.214c-1.502 0-2.737.501-3.703 1.502-.966 1.003-1.448 2.183-1.448 3.542v68.253c.001 1.646.823 2.916 2.469 3.808zm14.273-62.51h10.623c3.148 0 5.544.769 7.191 2.307 1.645 1.539 2.468 4.096 2.468 7.673 0 3.578-.823 6.135-2.468 7.673-1.647 1.538-4.043 2.307-7.191 2.307h-10.623v-19.96zM298.771 449.429c4.792 4.078 11.162 6.117 19.103 6.117 8.011 0 14.415-2.039 19.209-6.117 4.792-4.078 7.19-10.479 7.19-19.209v-28.439c0-8.727-2.398-15.131-7.19-19.209-4.794-4.078-11.198-6.117-19.209-6.117-7.941 0-14.311 2.039-19.103 6.117-4.793 4.078-7.19 10.482-7.19 19.209v28.439c0 8.73 2.397 15.131 7.19 19.209zm9.552-47.648c0-7.153 3.182-10.731 9.551-10.731 6.438 0 9.658 3.578 9.658 10.731v28.439c0 7.155-3.219 10.732-9.658 10.732-6.369 0-9.551-3.577-9.551-10.732v-28.439zM357.472 453.56c1.645.897 3.612 1.342 5.902 1.342 2.289 0 4.256-.445 5.902-1.342 1.645-.893 2.469-2.163 2.469-3.809v-25.864h7.083l14.702 28.547c1.073 2.076 2.86 3.111 5.365 3.111 2.504 0 4.883-.928 7.136-2.789 2.254-1.86 3.381-3.826 3.381-5.902 0-.786-.179-1.431-.537-1.932l-13.092-23.717c8.656-3.362 12.985-10.625 12.985-21.785 0-15.31-8.8-22.965-26.4-22.965h-22.214c-1.502 0-2.737.501-3.703 1.502-.966 1.003-1.448 2.183-1.448 3.542v68.253c.001 1.646.822 2.916 2.469 3.808zm14.273-62.51h10.624c3.148 0 5.544.769 7.191 2.307 1.645 1.539 2.468 4.096 2.468 7.673 0 3.578-.823 6.135-2.468 7.673-1.647 1.538-4.043 2.307-7.191 2.307h-10.624v-19.96z"
            fill="#000000"
            data-original="#000000"
            className=""
          ></path>
          <circle
            cx="56.17"
            cy="133.96"
            r="7.917"
            fill="#000000"
            data-original="#000000"
            className=""
          ></circle>
          <path
            d="M87.572 141.873h103.663a7.917 7.917 0 1 0 0-15.834H87.572a7.918 7.918 0 0 0 0 15.834zM471.619 118.123h-77.938a7.917 7.917 0 1 0 0 15.834h77.938a7.917 7.917 0 1 0 0-15.834zM471.619 152.165h-77.938a7.917 7.917 0 1 0 0 15.834h77.938a7.916 7.916 0 0 0 7.917-7.917 7.916 7.916 0 0 0-7.917-7.917zM471.619 186.206h-77.938a7.917 7.917 0 1 0 0 15.834h77.938a7.917 7.917 0 1 0 0-15.834zM471.619 220.247h-77.938a7.917 7.917 0 1 0 0 15.834h77.938a7.917 7.917 0 1 0 0-15.834zM471.619 254.289h-77.938c-4.373 0-7.917 3.544-7.917 7.917s3.544 7.917 7.917 7.917h77.938a7.916 7.916 0 0 0 7.917-7.917 7.916 7.916 0 0 0-7.917-7.917zM471.619 288.33h-77.938c-4.373 0-7.917 3.544-7.917 7.917s3.544 7.917 7.917 7.917h77.938c4.373 0 7.917-3.544 7.917-7.917s-3.544-7.917-7.917-7.917z"
            fill="#000000"
            data-original="#000000"
            className=""
          ></path>
          <circle
            cx="56.17"
            cy="167.21"
            r="7.917"
            fill="#000000"
            data-original="#000000"
            className=""
          ></circle>
          <path
            d="M87.572 175.123h54.402a7.917 7.917 0 1 0 0-15.834H87.572a7.918 7.918 0 0 0 0 15.834z"
            fill="#000000"
            data-original="#000000"
            className=""
          ></path>
          <circle
            cx="56.17"
            cy="265.37"
            r="7.917"
            fill="#000000"
            data-original="#000000"
            className=""
          ></circle>
          <path
            d="M169.472 257.456h-81.9c-4.373 0-7.917 3.544-7.917 7.917s3.544 7.917 7.917 7.917h81.9c4.373 0 7.917-3.544 7.917-7.917s-3.544-7.917-7.917-7.917z"
            fill="#000000"
            data-original="#000000"
            className=""
          ></path>
          <circle
            cx="56.17"
            cy="297.83"
            r="7.917"
            fill="#000000"
            data-original="#000000"
            className=""
          ></circle>
          <path
            d="M169.472 289.914h-81.9c-4.373 0-7.917 3.544-7.917 7.917s3.544 7.917 7.917 7.917h81.9c4.373 0 7.917-3.544 7.917-7.917s-3.544-7.917-7.917-7.917zM224.639 257.456h-28.92c-4.373 0-7.917 3.544-7.917 7.917s3.544 7.917 7.917 7.917h28.92a7.917 7.917 0 1 0 0-15.834zM166.522 167.206a7.917 7.917 0 0 0 7.917 7.917h54.402a7.917 7.917 0 1 0 0-15.834h-54.402a7.918 7.918 0 0 0-7.917 7.917z"
            fill="#000000"
            data-original="#000000"
            className=""
          ></path>
          <circle
            cx="56.17"
            cy="200.46"
            r="7.917"
            fill="#000000"
            data-original="#000000"
            className=""
          ></circle>
          <path
            d="M120.602 192.539a7.917 7.917 0 1 0 0 15.834h75.116a7.917 7.917 0 1 0 0-15.834h-75.116z"
            fill="#000000"
            data-original="#000000"
            className=""
          ></path>
          <circle
            cx="56.17"
            cy="232.12"
            r="7.917"
            fill="#000000"
            data-original="#000000"
            className=""
          ></circle>
          <path
            d="M257.606 224.206H120.602a7.917 7.917 0 1 0 0 15.834h137.004a7.916 7.916 0 0 0 7.917-7.917 7.916 7.916 0 0 0-7.917-7.917zM303.956 192.539H228.84a7.917 7.917 0 1 0 0 15.834h75.116a7.917 7.917 0 1 0 0-15.834z"
            fill="#000000"
            data-original="#000000"
            className=""
          ></path>
        </g>
      </svg>
    </Box>
    </>
  );
}
